"use strict";

define('components/tags',['jQuery', 'typeahead', 'components/strings', 'components/table', 'components/ajax'], function($, Bloodhound, stringsComponent, Table, ajax) {
    var tags = function() {
        this.removeTagHandler = function(e) {
            var remove_link = this;
            var url = $(remove_link).data('url');
            var content = {
                csrf_token: $('meta[name=csrf_token]').attr('content')
            }

            $.post(url, content, function(result) {
                if (result.status != 'ok') {
                    return;
                } else {
                    var tag_to_remove = $(remove_link).parent();
                    tag_to_remove.fadeOut(400, function() {
                        tag_to_remove.remove();

                        if($('#tag-list-body').children('.tag-removable').length == 0) {
                            $('#tag-list-empty').removeClass('hidden');
                    }
                    });
                }                
            });
        }


        this.init = function() {
            var taginput = $('#taginput');

            if(taginput.length) {
                this.initObjectPage(taginput);
            }
        }

        this.initObjectPage = function(taginput) {
            var self = this;

            self.configureTaginput(taginput, self.createDataSource(taginput));

            $("a.tag-remove").click(this.removeTagHandler);

            taginput.bind('typeahead:selected', function(event, datum, dataset_name) {
                var url = taginput.data('add-url');
                var object_type = taginput.data('object-type');
                var content = {
                    tag_id: datum.id,
                    tag_name: datum.label,
                    csrf_token: $('meta[name=csrf_token]').attr('content')
                };

                $.post(url, content, function(result) {
                    if (result.status == 'error') {
                        return;
                    } else if (result.status == 'ok') {
                        $('#tag-list-empty').addClass('hidden');
                        var new_tag = $(result.body).hide();
                        $('#tag-list-body').append(new_tag);
                        new_tag.fadeIn();
                        new_tag.find("a.tag-remove").click(self.removeTagHandler);
                    } else {
                        /* tag already exists; no action needed */
                    }
                });

                taginput.val('');
            });
        };

        this.initButtonBar = function(table) {
            var self = this;
            var taginput = $('#taginput-buttonbar');

            if(!taginput.length) {
                // Not needed on this page
                return;
            }

            self.configureTaginput(taginput, self.createDataSource(taginput));

            taginput.bind('typeahead:selected', function(event, datum, dataset_name) {
                // Tag all items in the selection
                var url = taginput.data('add-url');
                var object_type = taginput.data('object-type');

                var selected_object_ids = table.getSelectedObjectIds();

                // The csrf_token will be added in the ajax call below.
                var content = new FormData();
                content.append("object_type", object_type);
                content.append("tag_name", datum.label);
                content.append("object_ids", selected_object_ids);  // comma-separated IDs.

                ajax(url, {
                    formData: content,
                    onSuccess: function(result) {
                        var result_body = JSON.parse(result.body);
                        $('.cell-tags.hidden').removeClass('hidden');

                        for(var i = 0; i < result_body.object_ids.length; i++) {
                            var new_tag = $(result_body.tag_markup).hide();
                            table.appendToCell(result_body.object_ids[i], 'cell-tags', new_tag);
                            new_tag.fadeIn();
                        }
                        table.updateButtonBar();
                    }
                });

                taginput.val('');
            });
        }


        this.createDataSource = function(taginput) {
            var self = this;

            var tag_engine = new Bloodhound({
                name: 'tags',
                prefetch: {
                    url: taginput.data('prefetch-url'),
                    ttl: 1000 * 60  // one minute
                },
                datumTokenizer: function(d) {
                    return Bloodhound.tokenizers.whitespace(d.label);
                },
                queryTokenizer: Bloodhound.tokenizers.whitespace
            });

            tag_engine.initialize();
            var tag_engine_source = tag_engine.ttAdapter();

            return function(query, cb) {
                query = query.trim();
                tag_engine_source(query, function (results) {
                    var exactMatch = false;
                    for(var i = 0; i < results.length; i++) {
                        if(results[i].label.toUpperCase() === query.toUpperCase()) {
                            exactMatch = true;
                            break;
                        }
                    }

                    if(!exactMatch) {
                        results.push({id: null, label: query});
                    }
                    cb(results);
                });
            }
        }

        this.configureTaginput = function(taginput, data_source) {
            var self = this;

            taginput.typeahead({
                hint: false
            }, {
                source: data_source,
                displayKey: function(datum){return datum.label;},
                templates: {
                    suggestion: function(datum) {
                        if(datum.id === null) {
                            return '<b>"' + stringsComponent.escapeHtml(datum.label.trim()) + '"</b> (new tag)';
                        } else {
                            return stringsComponent.escapeHtml(datum.label);
                        }
                    }
                }
            }).blur(function(event) {
                $(this).val('');
            });

            taginput.closest('form').submit(function(e) { e.preventDefault(); });
        }
    }

    return tags;
});

